import { TipPreviewType } from "~/types/tip/TipPreviewType";

export const TipPreviewEntity = function (data: any): TipPreviewType {
    return {
        title: data?.attributes?.title,
        slug: data?.attributes?.slug,
        text: data?.attributes?.text,
    };
};